import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import makeStyles from '@mui/styles/makeStyles';
import { Box, Typography } from "@mui/material";
import logoSmartKood from "assets/img/logo-smartkood.png";
import Sidebar from "components/layout/Sidebar";
import Navbar from "components/layout/Navbar";
import PartnersListPage from "modules/partners/pages/partners-list.page";
import PartnerDetailPage from "modules/partners/pages/partner-detail.page";
import CompaniesListPage from "modules/companies/pages/companies-list.page";
import AccessRightsPage from "modules/access-rights/pages/access-rights.page";
// Hidden for the partner-management launch — restore together with the
// matching `hidden` flags in Sidebar.js.
// import UsersListPage from "modules/users/pages/users-list.page";
// import DashboardPage from "modules/dashboard/pages/dashboard.page";
// import ApprovalsListPage from "modules/approvals/pages/approvals-list.page";
// import ConsumerEngagementPage from "modules/consumer-engagement/pages/consumer-engagement.page";
// import EmailLogPage from "modules/email-log/pages/email-log.page";
// import MasterControlPage from "modules/master-control/pages/master-control.page";
// import DataSummaryPage from "modules/data-summary/pages/data-summary.page";
// import ManagementSnPage from "modules/management-sn/pages/management-sn.page";
// import AdminsPage from "modules/admins/pages/admins.page";

const DRAWER_WIDTH = 248;

const useStyles = makeStyles(() => ({
  root: { display: "flex", minHeight: "100vh" },
  content: {
    flexGrow: 1,
    padding: 24,
    marginTop: 68,
    minHeight: "calc(100vh - 68px)",
    backgroundColor: "#EBEDEE",
    display: "flex",
    flexDirection: "column",
  },
  main: {
    flexGrow: 1,
  },
  footer: {
    backgroundColor: "#FFFFFF",
    boxShadow: "0px -1px 0px 0px rgba(0,0,0,0.1)",
    padding: "20px 24px",
    marginTop: 24,
    marginLeft: -24,
    marginRight: -24,
    marginBottom: -24,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  footerPowered: {
    display: "flex",
    alignItems: "center",
    gap: 6,
  },
  footerPoweredText: {
    fontSize: 11,
    color: "#899498",
  },
  footerLogo: {
    height: 20,
    objectFit: "contain",
  },
}));

export default function AdminLayout() {
  return <LayoutInner />;
}

function LayoutInner() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Navbar drawerWidth={DRAWER_WIDTH} />
      <Sidebar drawerWidth={DRAWER_WIDTH} />
      <div className={classes.content}>
        <div className={classes.main}>
          <Switch>
            <Route exact path="/admin/partners" component={PartnersListPage} />
            <Route path="/admin/partners/:uuid" component={PartnerDetailPage} />
            <Route exact path="/admin/companies" component={CompaniesListPage} />
            <Route exact path="/admin/partner-access-rights" component={AccessRightsPage} />
            {/* Hidden for the partner-management launch (see Sidebar.js). Any
                hidden URL falls through to the Partners redirect below. */}
            {/* <Route exact path="/admin/users" component={UsersListPage} /> */}
            {/* <Route exact path="/admin/dashboard" component={DashboardPage} /> */}
            {/* <Route exact path="/admin/approvals" component={ApprovalsListPage} /> */}
            {/* <Route exact path="/admin/consumer-engagement" component={ConsumerEngagementPage} /> */}
            {/* <Route exact path="/admin/email-log" component={EmailLogPage} /> */}
            {/* <Route exact path="/admin/master-control" component={MasterControlPage} /> */}
            {/* <Route exact path="/admin/data-summary" component={DataSummaryPage} /> */}
            {/* <Route exact path="/admin/management-sn" component={ManagementSnPage} /> */}
            {/* <Route exact path="/admin/admins" component={AdminsPage} /> */}
            <Redirect from="/admin" to="/admin/partners" />
          </Switch>
        </div>
        <Box className={classes.footer}>
          <Box className={classes.footerPowered}>
            <Typography className={classes.footerPoweredText}>Powered by</Typography>
            <img src={logoSmartKood} alt="SmartKood" className={classes.footerLogo} />
          </Box>
        </Box>
      </div>
    </div>
  );
}
